import React from 'react';
import './App.css';
import Router from './Route';
import 'bootstrap/dist/css/bootstrap.min.css';

function App() {
  return (
    <>
    
      <Router />
    </>
  );
}

export default App;